<template>
  <div>
    <v-card outlined class="pa-2 d-flex align-center gap-4 rounded-lg">
      <v-progress-circular v-if="loading" indeterminate size="50" />
      <v-icon v-else size="50">
        {{ deploymentStatusMap[deployment?.status]?.icon }}
      </v-icon>
      <div>
        <h6 class="mb-0">
          {{ deploymentStatusMap[deployment?.status]?.text }}
        </h6>
        <p class="mb-0 lh-1">
          Atualizado
          {{
            [new Date(deployment?.buildingAt || deployment?.createdAt)]
              | dateDiff(true)
          }}
        </p>

        <small
          v-if="deployment?.buildingAt < platform?.updatedAt"
          class="error--text lh-1"
        >
          Desincronizado
        </small>
      </div>
      <v-spacer />
      <v-btn
        v-if="deployment?.buildingAt < platform?.updatedAt"
        @click="createDeployment"
        :loading="loading || deployment?.status !== 'READY'"
        color="primary"
        text
      >
        Publicar
      </v-btn>
    </v-card>

    <v-alert v-if="error" type="error" class="mb-0 mt-1">
      {{ error }}
    </v-alert>
  </div>
</template>

<script>
import platformService from "@/services/admin/platform";

export default {
  name: "PlatformDeploymentStatus",

  props: {
    platform: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      error: null,
      deployment: null,
      deploymentStatusMap: {
        BUILDING: {
          text: "Preparando para publicação",
          color: "warning",
          icon: "mdi-clock",
        },
        READY: {
          text: "Publicado com sucesso",
          color: "success",
          icon: "mdi-check",
        },
        INITIALIZING: {
          text: "Iniciando publicação",
          color: "info",
          icon: "mdi-clock",
        },
        QUEUED: {
          text: "Em fila para publicação",
          color: "warning",
          icon: "mdi-clock",
        },
      },
    };
  },

  methods: {
    async createDeployment() {
      try {
        this.loading = true;
        const response = await platformService.createDeployment(
          this.platform.id
        );
        this.deployment = response.deployment;
      } catch (error) {
        this.error = error.message || "Erro ao criar implantação";
      } finally {
        this.loading = false;
      }
    },
    async getDeployment() {
      try {
        this.loading = true;
        const response = await platformService.getDeployment(this.platform.id);
        this.deployment = response.deployment;
      } catch (error) {
        this.error = error.message || "Erro ao carregar status de implantação";
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.getDeployment();
  },
};
</script>
